export default "__VITE_ASSET__lqo$UmUl__"